import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["title", "company", "logo", "logopreview", "structure", "contrat", "experience", "locality", "previewCard", "color", "pinned", "pinpreview", "cardpreview", "desktoptags", "mobiletags"];

    connect() {
        this.element.addEventListener('autocomplete.change', this.handleAutocompleteChange);
        this.updatePreview();
        if (this.hasLogoTarget) {  // Only call updateLogo if the logo target exists
            this.updateLogo();
        }
    }

    handleAutocompleteChange = (event) => {
        const { textValue } = event.detail;
        this.localityTarget.textContent = textValue.replace(/\d+/g, "");
        this.updatePreview();
    }


    updatePreview() {
        this.previewCardTarget.querySelector('.job-title').textContent = this.titleTarget.value || 'Titre du poste';
        this.previewCardTarget.querySelector('.job-company').textContent = this.companyTarget.textContent || "Nom de l'entreprise";
        this.previewCardTarget.querySelector('.job-locality').textContent = this.localityTarget.textContent || 'Localisation du poste';

        this.updateTags();
        this.updateFeatures();
        if (this.hasLogoTarget) {
            this.updateLogo();  // Ensure updateLogo is only called if logoTarget exists
        }
    }


    updateLogo() {
        // Ensure logoTarget is used only if it's confirmed to exist
        if (this.hasLogoTarget && this.logoTarget.dataset.logoUrl) {
            const companyLogoUrl = this.logoTarget.dataset.logoUrl;
            this.logopreviewTarget.innerHTML = `<img src="${companyLogoUrl}" alt="Company Logo" class="object-contain md:h-24 md:w-24 w-24 h-24 rounded-lg" loading="lazy">`;
        } else {
            this.setDefaultLogo();
        }
    }


    readURL(event) {
        const input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = (e) => {
                this.logopreviewTarget.innerHTML = `<img src="${e.target.result}" alt="Uploaded Logo" class="object-contain md:h-24 md:w-24 w-24 h-24 rounded-lg" loading="lazy">`;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    setDefaultLogo() {
        this.logopreviewTarget.innerHTML = `<div class='p-5 text-slate-300 relative inline-flex items-center justify-center overflow-hidden bg-white object-contain md:h-24 md:w-24 w-24 h-24 rounded-lg'><svg aria-hidden='true' fill='none' stroke='currentColor' stroke-width='1.5' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
          <path d='M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21' stroke-linecap='round' stroke-linejoin='round'></path>
        </svg></div>`;
    }

    updateTags() {

        let contratTag = ""
        const contratText = this.contratTarget.options[this.contratTarget.selectedIndex].text
        if (contratText !== "") {
            contratTag = this.createTag(contratText, "contrat");
        }

        let experienceTag = ""
        const experienceText = this.experienceTarget.options[this.experienceTarget.selectedIndex].text
        if (experienceText !== "") {
            experienceTag = this.createTag(`Exp. ${experienceText}`, "experience");
        }

        let structureTag = "";

        // Check if the structure target is a SELECT element or not
        if (this.structureTarget.tagName === 'SELECT') {
            // It's a select element, get the selected text
            const selectedIndex = this.structureTarget.selectedIndex;
            if (selectedIndex > 0) { // Ensure that an option is selected
                const structureText = this.structureTarget.options[selectedIndex].text;
                structureTag = this.createTag(structureText, "structure");
            }
        } else {
            // It's a regular text container
            const structureText = this.structureTarget.textContent;
            if (structureText !== "") {
                structureTag = this.createTag(structureText, "structure");
            }
        }


        // Clear existing tags
        this.desktoptagsTarget.innerHTML = '';
        this.mobiletagsTarget.innerHTML = '';

        // Append new tags
        this.desktoptagsTarget.insertAdjacentHTML('beforeend', contratTag);
        this.desktoptagsTarget.insertAdjacentHTML('beforeend', experienceTag);
        this.desktoptagsTarget.insertAdjacentHTML('beforeend', structureTag);
        this.mobiletagsTarget.insertAdjacentHTML('beforeend', contratTag);
        this.mobiletagsTarget.insertAdjacentHTML('beforeend', experienceTag);
        this.mobiletagsTarget.insertAdjacentHTML('beforeend', structureTag);
    }

    createTag(text, type) {
        const tagColor = this.colorTarget.checked ? 'bg-amber-200 text-amber-800' : 'bg-slate-100 text-slate-800';
        return `<span class='mr-2 my-1 whitespace-nowrap cursor-default ${tagColor} text-xs font-medium px-2.5 py-0.5 rounded-full'>${text}</span>`;
    }

    updateFeatures() {
        // Update feature presentation based on feature selections
        if (this.pinnedTarget.checked) {
            this.pinpreviewTarget.classList.add('absolute')
            this.pinpreviewTarget.classList.remove('hidden')
        } else {
            this.pinpreviewTarget.classList.add('hidden')
            this.pinpreviewTarget.classList.remove('absolute')
        }

        if (this.colorTarget.checked) {
            this.cardpreviewTarget.classList.add('bg-amber-50', 'border-amber-200');
            this.cardpreviewTarget.classList.remove('bg-white', 'border-stone-100');
        } else {
            this.cardpreviewTarget.classList.add('bg-white', 'border-stone-100');
            this.cardpreviewTarget.classList.remove('bg-amber-50', 'border-amber-200');
        }
    }
}
